/* 🤖 this file was generated by script */
export const wiconCollapse01 = {
  name: 'collapse_01',
  data: `<svg viewBox="0 0 16 16"><path fill="currentColor" d="M6.67 8.67c.36 0 .66.3.66.66v4a.67.67 0 01-1.33 0v-2.4l-3.53 3.54a.67.67 0 01-.94-.94L5.06 10h-2.4a.67.67 0 010-1.33h4zm6.86-7.14a.67.67 0 01.94.94L10.94 6h2.4a.67.67 0 010 1.33h-4a.67.67 0 01-.67-.66v-4a.67.67 0 011.33 0v2.4l3.53-3.54z"/></svg>`,
};
